export const API = {
  LOGIN: "login/app",
  LOGIN_WITH_OTP: "login/otp",
  LOGIN_SEND_OTP: "auth/send-otp",
  SIGNUP: "signup",
  RESET_PASSWORD: "auth/reset-password",
  VERIFY_OTP: "auth/verify-otp",
  COMM_USER_PROFILE: "commercial-user/profile",
  PROFILE: "user/profile",
  PROFILE_IMAGE: "user/profile-image",
  HRM_PROFILE: "hrm/user/profile",
  PWD_RESET: "hrm/password/reset",
  COURSE_HOME_DATA: "commercial-user/home?includeCourseDetails=true&includeAnalytics=true&groupCoursesByTags=true",
  SUBSCRIPTION_DATA: "commercial-user/subscriptions?includeCourseDetails=true&includeAnalytics=true",
  TERMS_AND_CONDITIONS_STATUS: "user-consents/TERMS_AND_CONDITIONS/status",
  TERMS_AND_CONDITIONS : `legal-documents/TERMS_AND_CONDITIONS/latest`,
  REGISTER_CONSENT: "user-consents",
  PASSWORD: "user/password",
  REFRESH_TOKEN: "auth/refresh",
  NOTIFICATION_UNREAD: "notifications/app/unread",
  NOTIFICATION_ACK: "notifications/acknowledge",
  PROILE_IMG: "user/profile-image",
  CREATE_SUPPORT_TICKET: "support/ticket/mobile",
  GET_SUPPORT_TICKETS:"support/my-requests?includeFiles=true",
  CREATE_ORDER: "payments/orders",
  VERIFY_ORDER: "payments/verify",
  GET_ORDER: "payments/orders/:orderId",
  ENROLLED_COURSE: "user/subscriptions/:subscriptionPlanId/enroll",
  SUBCRIPTION_HOME_DATA: "commercial-user/online-pathshala/home",
  DOWNLOAD_SUBSCRIPTION_INVOICE: "invoice/subscriptions/:subscriptionId",
  TENANT_INFO: "tenants/:tenantId/info?categories=BRANDING,ADDRESS",
  SUBSCRIPTION_PRICING: "payments/orders/entity/:subscriptionPlanId/pricing-breakdown?entityType=COURSE_SUBSCRIPTION_PLAN",
  ADDRESS: "user/address"
};

export const AI_FEATURES_ID = {
  CHAT_ASSISTANT: "AI_CA_001",
  ASSESSMENT_GENERATOR : "AI_AG_001",
  SYLLABUS_GENERATOR: "AI_SG_001",
}

export const CURRICULUM_TYPE = [
  { value: "Select", label: "Select" },
  { value: "SEMESTER", label: "Semester" },
  { value: "YEAR", label: "Year" },
];

export const COURSE_TYPE = [
  { value: "Select", label: "Select" },
  { value: "ACADEMIC", label: "ACADEMIC" },
  { value: "SPORTS", label: "SPORTS" },
  { value: "SCIENCE", label: "SCIENCE" },
  { value: "MATH", label: "MATH" },
  { value: "HISTORY", label: "HISTORY" },
  { value: "GEOGRAPHY", label: "GEOGRAPHY" },
  { value: "ACADEMIC", label: "Academic" },
  { value: "PHYSICS", label: "PHYSICS" },
  { value: "CHEMISTRY", label: "CHEMISTRY" },
  { value: "BIOLOGY", label: "BIOLOGY" },
  { value: "ENGLISH", label: "ENGLISH" },
  { value: "ART", label: "ART" },
  { value: "MUSIC", label: "MUSIC" },
  { value: "COMPUTER_SCIENCE", label: "COMPUTER SCIENCE" },
];

export const GENDER = [
  { value: "M", label: "Male" },
  { value: "F", label: "Female" },
  { value: "O", label: "Others" },
];


export const MONTHS_OPTS = [
  {
    value: '01',
    label: "January",
  },
  {
    value: '02',
    label: "February",
  },
  {
    value: '03',
    label: "March",
  },
  {
    value: '04',
    label: "April",
  },
  {
    value: '05',
    label: "May",
  },
  {
    value: '06',
    label: "June",
  },
  {
    value: '07',
    label: "July",
  },
  {
    value: '08',
    label: "August",
  },
  {
    value: '09',
    label: "September",
  },
  {
    value: '10',
    label: "October",
  },
  {
    value: '11',
    label: "November",
  },
  {
    value: '12',
    label: "December",
  }
]

export const SUBSCRIPTION_PLAN_TYPES = [
  { value: "FREE", label: "Free" },
  { value: "DEFAULT", label: "Default" },
  { value: "PREMIUM", label: "Premium" },
];

export const DIFFICULTY_LEVELS = [
  { label: "Beginner", value: "Beginner" },
  { label: "Intermediate", value: "Intermediate" },
  { label: "Advanced", value: "Advanced" }
];

export const GST_STATES =  [
  {
    "label": "Jammu & Kashmir",
    "value": "01"
  },
  {
    "label": "Himachal Pradesh",
    "value": "02"
  },
  {
    "label": "Punjab",
    "value": "03"
  },
  {
    "label": "Chandigarh",
    "value": "04"
  },
  {
    "label": "Uttarakhand",
    "value": "05"
  },
  {
    "label": "Haryana",
    "value": "06"
  },
  {
    "label": "Delhi",
    "value": "07"
  },
  {
    "label": "Rajasthan",
    "value": "08"
  },
  {
    "label": "Uttar Pradesh",
    "value": "09"
  },
  {
    "label": "Bihar",
    "value": "10"
  },
  {
    "label": "Sikkim",
    "value": "11"
  },
  {
    "label": "Arunachal Pradesh",
    "value": "12"
  },
  {
    "label": "Nagaland",
    "value": "13"
  },
  {
    "label": "Manipur",
    "value": "14"
  },
  {
    "label": "Mizoram",
    "value": "15"
  },
  {
    "label": "Tripura",
    "value": "16"
  },
  {
    "label": "Meghalaya",
    "value": "17"
  },
  {
    "label": "Assam",
    "value": "18"
  },
  {
    "label": "West Bengal",
    "value": "19"
  },
  {
    "label": "Jharkhand",
    "value": "20"
  },
  {
    "label": "Odisha",
    "value": "21"
  },
  {
    "label": "Chhattisgarh",
    "value": "22"
  },
  {
    "label": "Madhya Pradesh",
    "value": "23"
  },
  {
    "label": "Gujarat",
    "value": "24"
  },
  {
    "label": "Dadra and Nagar Haveli and Daman and Diu",
    "value": "26"
  },
  {
    "label": "Maharashtra",
    "value": "27"
  },
  {
    "label": "Karnataka",
    "value": "29"
  },
  {
    "label": "Goa",
    "value": "30"
  },
  {
    "label": "Lakshadweep",
    "value": "31"
  },
  {
    "label": "Kerala",
    "value": "32"
  },
  {
    "label": "Tamil Nadu",
    "value": "33"
  },
  {
    "label": "Puducherry",
    "value": "34"
  },
  {
    "label": "Andaman & Nicobar Islands",
    "value": "35"
  },
  {
    "label": "Telangana",
    "value": "36"
  },
  {
    "label": "Andhra Pradesh (New)",
    "value": "37"
  },
  {
    "label": "Ladakh",
    "value": "38"
  },
  {
    "label": "Other Territory",
    "value": "97"
  },
  {
    "label": "Center Jurisdiction",
    "value": "99"
  }
]

/**
 * Maps URL subdomains to tenant IDs.
 * Example: acme.app.example.com → subdomain "acme" → tenant "acme-tenant-uuid"
 */
export const SUBDOMAIN_TENANT_MAP: Record<string, string> = {
  "self-selection-board": "ssbmrt",
  "self-selection-board-stage": "ssbmrt",
};